module.exports = __webpack_public_path__ + "static/media/SourceSansPro-BoldIt.08c86595.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-BoldIt.svg
// module id = 355
// module chunks = 3